import React from 'react';
import { Card } from './Card';
import { TrendingUp, TrendingDown } from 'lucide-react';

export const StatCard = ({
  title,
  value,
  subtitle,
  icon: Icon,
  trend,
  trendValue,
  color = 'brand',
  className = '',
}) => {
  const colorStyles = {
    brand: 'text-brand-600 dark:text-brand-400 bg-teal-50 dark:bg-teal-950/60 border-teal-100 dark:border-teal-900/60',
    emerald: 'text-emerald-600 dark:text-emerald-400 bg-emerald-50 dark:bg-emerald-950/60 border-emerald-100 dark:border-emerald-900/60',
    amber: 'text-amber-600 dark:text-amber-400 bg-amber-50 dark:bg-amber-950/60 border-amber-100 dark:border-amber-900/60',
    blue: 'text-sky-600 dark:text-sky-400 bg-sky-50 dark:bg-sky-950/60 border-sky-100 dark:border-sky-900/60',
    rose: 'text-rose-600 dark:text-rose-400 bg-rose-50 dark:bg-rose-950/60 border-rose-100 dark:border-rose-900/60',
    indigo: 'text-indigo-600 dark:text-indigo-400 bg-indigo-50 dark:bg-indigo-950/60 border-indigo-100 dark:border-indigo-900/60',
  };

  return (
    <Card hover className={`p-5 relative overflow-hidden ${className}`}>
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <p className="text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400">
            {title}
          </p>
          <p className="text-2xl font-bold text-slate-900 dark:text-slate-100 mt-1 font-sans">
            {value}
          </p>

          {(subtitle || trendValue) && (
            <div className="mt-2 flex items-center gap-2">
              {trendValue && (
                <span
                  className={`inline-flex items-center text-xs font-semibold ${
                    trend === 'up'
                      ? 'text-emerald-600 dark:text-emerald-400'
                      : trend === 'down'
                      ? 'text-rose-600 dark:text-rose-400'
                      : 'text-slate-500'
                  }`}
                >
                  {trend === 'up' && <TrendingUp className="w-3.5 h-3.5 mr-0.5" />}
                  {trend === 'down' && <TrendingDown className="w-3.5 h-3.5 mr-0.5" />}
                  {trendValue}
                </span>
              )}
              {subtitle && (
                <span className="text-xs text-slate-500 dark:text-slate-400">
                  {subtitle}
                </span>
              )}
            </div>
          )}
        </div>

        {Icon && (
          <div className={`p-3 rounded-2xl border flex-shrink-0 ${colorStyles[color] || colorStyles.brand}`}>
            <Icon className="w-5 h-5" />
          </div>
        )}
      </div>
    </Card>
  );
};
